import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Select } from "@/components/elements/Select";
import { Avatar, Grid, Stack, Typography } from "@mui/material";
import { deepOrange, deepPurple, blue, green, pink, amber } from "@mui/material/colors";
import { FC, useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";
import { TPartnerForm } from "@/features/talent/types/partnerForm";
import { divider } from "@/theme/colors";

type TPartnerContactInfoFormProps = {
  readonly?: boolean;
};

const colors = [deepOrange[500], deepPurple[500], blue[500], green[500], pink[500], amber[500]];
const getRandomColor = () => {
  const index = Math.floor(Math.random() * colors.length);
  return colors[index];
};

export const PartnerContactInfoForm: FC<TPartnerContactInfoFormProps> = ({ readonly }) => {
  const { control } = useFormContext<TPartnerForm>();
  const { partnerId } = useParams();

  const [bgColor] = useState<string>(() => {
    if (!partnerId) {
      return getRandomColor();
    }
    const savedColor = localStorage.getItem(`partnerBgColor_${partnerId}`);
    if (savedColor) return savedColor;
    const newColor = getRandomColor();
    localStorage.setItem(`partnerBgColor_${partnerId}`, newColor);
    return newColor;
  });

  const contactPerson = useWatch({ control, name: "contactPerson" });
  const [firstChar, setFirstChar] = useState<string>();

  useEffect(() => {
    if (contactPerson) {
      const char = contactPerson.charAt(0).toUpperCase();
      setFirstChar(char);
    }
  }, [contactPerson]);

  return (
    <InnerBox title={<Typography variant="sub16Bold">担当者情報</Typography>} showDivider={false} borderColor={divider.high} sx={{ gap: "24px" }}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FormField
            control={control}
            name="contactPerson"
            sx={{
              label: { marginLeft: "50px" },
              "p.Mui-error": { marginLeft: "50px" },
            }}
          >
            <Stack direction="row" alignItems="center" gap={2}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: bgColor, fontSize: "16px" }}>{firstChar}</Avatar>
              <Input readonly={readonly} sx={{ width: "100%" }} />
            </Stack>
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="contactMethod">
            <Select enumName="EPartnerContactMethod" readonly={readonly} />
          </FormField>
        </Grid>
        <Grid item xs={4}>
          <FormField control={control} name="phoneNumber">
            <Input readonly={readonly} />
          </FormField>
        </Grid>
        <Grid item xs={4}>
          <FormField control={control} name="email">
            <Input readonly={readonly} />
          </FormField>
        </Grid>
        <Grid item xs={4}>
          <FormField control={control} name="otherContacts">
            <Input readonly={readonly} />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
